
// @ts-ignore
    import __i18nConfig from '@next-translate-root/i18n'
// @ts-ignore
    import __loadNamespaces from 'next-translate/loadNamespaces'
// @ts-ignore
    
import React from "react";

import { Heading } from "@/components/Heading";
import { Image } from "@/components/Image";
import { Grid } from "@/components/Grid";
import { BlogText } from "@/components/BlogText";
import { CTASection } from "@/sections/CTASection";
import { Head } from "@/components/Head";
import { useTheme } from "@/hooks/useTheme";

const OpenXdInBuilderX = () => {
  const { colors } = useTheme();
  return (
    <>
      <Head
        pageNamespace="page/open-xd-in-builderx"
        ogImage="/images/main-og-image.jpg"
      />

      <div>
        <Grid
          customStyle={{
            maxWidth: 800,
            flexDirection: "column",
            alignItems: "flex-start",
            paddingBottom: "0 !important",
          }}
        >
          <Heading as="h1">Open XD files in BuilderX</Heading>
          <BlogText>
            BuilderX is a great program to convert designs from Sketch, but what
            if you are using a popular tool like Adobe XD?
          </BlogText>
          <BlogText>
            Currently, it is not possible to import Adobe XD files to BuilderX,
            but we have a great way for you to do this using our converter.
          </BlogText>
          <BlogText>
            Firstly we need to make our XD files readable by BuilderX. In order
            for us to do this, we need to first &nbsp;
            <a
              href="/"
              style={{
                color: colors.RED,
                fontWeight: "bold",
              }}
            >
              convert our XD file into Sketch
            </a>
            &nbsp; (which BuilderX can directly import).
          </BlogText>
          <BlogText>Now let’s get started.</BlogText>

          <section>
            <Heading as="h3">Convert XD to Sketch</Heading>
            <ol>
              <li>
                <BlogText>
                  <strong>Upload your file to Magicul</strong>
                  &nbsp;-&nbsp;go to our &nbsp;
                  <a
                    href="/"
                    style={{
                      color: colors.RED,
                      fontWeight: "bold",
                    }}
                  >
                    XD to Sketch converter
                  </a>
                  &nbsp; and drag a file to the converter or click on browse to
                  upload your file.
                </BlogText>
                <Image
                  customStyle={{ width: "100%", marginBottom: 29 }}
                  src="/images/tutorials/uploading-image.jpg"
                  alt="Magicul uploading dialog"
                />
              </li>
              <li>
                <BlogText>
                  <strong>Select your plan</strong>
                  &nbsp;-&nbsp;Click on convert now and select your plan.
                </BlogText>
              </li>
              <li>
                <BlogText>
                  <strong>Complete the checkout</strong>
                  &nbsp;-&nbsp;enter your details and complete the checkout.
                  Your file will now convert from the XD to Sketch/Figma.
                </BlogText>
              </li>
              <li>
                <BlogText>
                  <strong>Download your file</strong>
                  &nbsp;-&nbsp;click the arrow button to download the converted
                  file.
                </BlogText>
                <Image
                  customStyle={{ width: "100%", marginBottom: 29 }}
                  src="/images/tutorials/downloading-image.jpg"
                  alt="Magicul downloading dialog"
                />
              </li>
            </ol>
            <BlogText>
              Once you have converted your XD file into the Sketch format it’s
              time to import it into BuilderX.
            </BlogText>
          </section>
          <section>
            <Heading as="h3">Import your file into BuilderX</Heading>
            <ol>
              <li>
                <BlogText>Open BuilderX.</BlogText>
              </li>
              <li>
                <BlogText>
                  To open your Sketch file drag the file into an open project.
                </BlogText>
                <BlogText customStyle={{ textAlign: "center" }}>OR</BlogText>
                <BlogText>
                  Click on the hamburger menu in the top left of the screen and
                  select File &gt; Import from Sketch file.
                </BlogText>
                <Image
                  customStyle={{ width: "100%", marginBottom: 29 }}
                  src="/images/tutorials/open-xd-in-builderx/import-sketch-dialog.jpg"
                  alt="import sketch dialog"
                />
              </li>
              <li>
                <BlogText>
                  Select the relevant artboards to import into the BuilderX
                  project.
                </BlogText>
                <Image
                  customStyle={{ width: "100%", marginBottom: 29 }}
                  src="/images/tutorials/open-xd-in-builderx/select-artboards.jpg"
                  alt="select artboards"
                />
              </li>
              <li>
                <BlogText>The file should take a few moments to load.</BlogText>
                <Image
                  customStyle={{ width: "100%", marginBottom: 29 }}
                  src="/images/tutorials/open-xd-in-builderx/sketch-import-progress.jpg"
                  alt="sketch import progress"
                />
              </li>
            </ol>
            <BlogText>
              You are now ready to use all the features of BuilderX with your
              converted file.
            </BlogText>
            <CTASection
              title="Want to convert XD files to BuilderX?"
              buttonLabel="Start Now"
              href="/"
            />
          </section>
        </Grid>
      </div>
    </>
  );
};

export default OpenXdInBuilderX;


// @ts-ignore
    export async function getStaticProps(ctx) {
// @ts-ignore
        
// @ts-ignore
        
// @ts-ignore
        return {
// @ts-ignore
          
// @ts-ignore
          
// @ts-ignore
          props: {
// @ts-ignore
            
// @ts-ignore
            ...(await __loadNamespaces({
// @ts-ignore
              ...ctx,
// @ts-ignore
              pathname: '/tutorials/open-xd-in-builderx',
// @ts-ignore
              loaderName: 'getStaticProps',
// @ts-ignore
              ...__i18nConfig,
// @ts-ignore
              
// @ts-ignore
            }))
// @ts-ignore
          }
// @ts-ignore
        }
// @ts-ignore
    }
// @ts-ignore
  